import React from "react";

export default class StatusBanner extends React.Component {

    componentDidMount() {
        const { scrollTop } = this.props;
        if (typeof scrollTop !== 'undefined' && typeof window !== 'undefined' && scrollTop) {
             window.scrollTo(0, 0);
        }
    }

    // SETS STATUS BANNER ALIGNMENT TO LEFT OR DEFAULT
    setBannerAlignment(bannerAlignment) {
        switch (bannerAlignment) {
            case 'left':
                return 'banner-left';
            default:
                return '';
        }
    }
   
    render() {
        const { statusClass, bannerAlignment, statusIcon, bannerMsg, subBannerMsg, failedStatus, children } = this.props;
        let bannerStatusClass = statusClass ? statusClass : (failedStatus ? "status-failure" : "status-success");
        let bannerStatusIcon = statusIcon ? statusIcon : (failedStatus ? "icon-error" : "icon-list-check");
        let bannerAlignClass = this.setBannerAlignment(bannerAlignment);

        return (
            <React.Fragment>
                <div className={ `row status-banner-container ${bannerAlignClass} ${bannerStatusClass}`}>
                    <div className="col-12 align-self-center maxWidth-content status-banner-msg">
                        <div className="status-icon-container"><span className={bannerStatusIcon} /></div>
                        <h1>{bannerMsg}</h1>
                    </div>
                </div>
                {subBannerMsg &&
                    <div className={`row status-subBanner-container ${bannerAlignClass} ${bannerStatusClass}`}>
                        <div className="col-12 maxWidth-content align-self-center status-subBanner-msg">
                            <h2>{subBannerMsg}</h2>
                        </div>
                    </div>
                }
                {
                    children &&
                    <div className={`row status-subBanner-container ${bannerAlignClass} ${bannerStatusClass}`}>
                        <div className="col-12 maxWidth-content align-self-center status-subBanner-msg">
                            {children}
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}